import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { executeElementScripts } from '../../util';

class Player extends Component {
	static propTypes = {
		setPlayerLoaded: PropTypes.func.isRequired
	}

	shouldComponentUpdate() {
    	return false;
	}

	componentDidMount() {
		const { visible } = this.props;

		if (visible && window.setupMedia !== undefined) {
			window.setupMedia(this.mediaContainer, this.props.setPlayerLoaded);
			executeElementScripts(this.mediaContainer);
		}
	}

	render() {
		const { visible, iframe } = this.props;

		if (!visible) {
			return null;
		}

		if (iframe) {
			return <div className="container">
				<div className="embed-responsive-item" ref={(input) => { this.mediaContainer = input; }}>
					<img alt="media placeholder" className="img-responsive" src="/wsimages/loading_1600x900.png" />
				</div>
			</div>;
		} else {
			return <div className="embed-responsive-item" ref={(input) => { this.mediaContainer = input; }}>
				<img alt="media placeholder" className="img-responsive" src="/wsimages/loading_1600x900.png" />
			</div>;
		}
	}
};

export default Player;